export const RECEIVE_METER_TYPES = 'RECEIVE_METER_TYPES';
export const GET_METER_TYPES = 'GET_METER_TYPES';
export const SET_METER_TYPE = 'SET_METER_TYPE';
export const UPDATE_METER_TYPE = 'UPDATE_METER_TYPE';
export const DELETE_METER_TYPE = 'DELETE_METER_TYPE';
export const FETCH_METER_TYPES = 'FETCH_METER_TYPES';
